import { render, staticRenderFns } from "./LiveStatsCard.vue?vue&type=template&id=d6a4b67e&scoped=true"
import script from "./LiveStatsCard.vue?vue&type=script&lang=js"
export * from "./LiveStatsCard.vue?vue&type=script&lang=js"
import style0 from "./LiveStatsCard.vue?vue&type=style&index=0&id=d6a4b67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a4b67e",
  null
  
)

export default component.exports